<div class="bg-white min-h-screen" *ngIf="activeStage$ | async as activeStage">
    <div class="checkout-process__inner">
        <vsf-breadcrumbs [items]="breadcrumbItems"></vsf-breadcrumbs>
        <h2 class="sr-only">Checkout</h2>
        <div
            class="w-full items-start mt-8"
            [ngClass]="isOrderCompleted ? 'gap-2' : 'gap-8 md:flex'"
        >
            <div class="checkout-process__main">
                <router-outlet></router-outlet>
            </div>
            <vsf-order-summary-card
                *ngIf="!isOrderCompleted"
                class="md:sticky md:top-8 self-start"
                [order]="cart$ | async"
                [activeStage]="activeStage"
                [canAdjustQuantities]="false"
                [canProceedToPayment]="canProceedToPayment$ | async"
                [hasPaymentMethod]="hasPaymentMethod$ | async"
                [isOrderCompleted]="isOrderCompleted"
                [signedIn]="signedIn$ | async"
                [stripeSurchargePercent]="
                    (globalService.stripeSurchargePercent$ | async) || 0
                "
                [isStripeSelected]="
                    (globalService.isStripeSelected$ | async) || false
                "
                (proceedToPayment)="triggerProceedToPayment()"
                (changeShippingAddress)="changeShippingAddress()"
            ></vsf-order-summary-card>
        </div>
    </div>
</div>
